const BASE_URL =  'https://cassuss.com'
export default (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "description": product.description,
  "sku": product.sku || product.id,
  "image": 'https://api.cassuss.com/product/product_images'+product.images,
  "brand": {
    "@type": "Brand",
    "name": product.brand?.name || "Cassuss E-commerce"
  },
  "offers": {
    "@type": "Offer",
    "price": product.promo_price || product.price,
    "priceCurrency": "XAF",
    "availability": product.in_stock
      ? "https://schema.org/InStock"
      : "https://schema.org/OutOfStock",
    "url": `${BASE_URL}/product/${product.slug}`
  },
  ...(product.rating && {
    aggregateRating: {
      "@type": "AggregateRating",
      "ratingValue": product.rating,
      "reviewCount": product.review_count || 1
    }
  })
})
